// Centralised notices for transient messaging
export const REBRAND_NOTICE =
  "Heads up: we’re migrating auth to layerbound.com soon.";